import { createRoot } from "react-dom/client";
import React, { StrictMode } from "react";
import { BrowserRouter } from "react-router-dom";
import { loadEnvSettings } from "./utilities/loadEnvSettings";
import App from "./App";

// const router = createBrowserRouter([
//   {
//     path: "/",
//     element: <HomePage />,
//   },
//   {
//     path: "/admin",
//     element: <AdminPage />,
//   },
//   {
//     path: "/how-to-install",
//     element: <HowToInstallPage />,
//   },
//   {
//     path: "/apps/:appId",
//     element: <AppPage />,
//   },
// ]);

function run() {
  try {
    // This exists to provide a response to a "health check" query. If `OK` isn't returned, something is wrong.
    if (window.location.pathname === "/ping") {
      return (document.body.innerHTML = "OK");
    }

    loadEnvSettings();

    createRoot(document.getElementById("root") as HTMLElement).render(
      <StrictMode>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </StrictMode>
    );
  } catch (error) {
    console.error("run: ", error);
  }
}

void run();
